import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
    },
    limegreen: {
      200: "#98e698",
    },
    darkorange: {
      200: "#ffc680",
    },
    deeppink: {
      200: "#ff8ac9",
    },
    dodgerblue: {
      200: "#8ec8ff",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode("gray.50", "gray.800")(props),
        fontFamily: 'Helvetica, sans-serif'
      },
      html: {
        fontFamily: 'Helvetica, sans-serif'
      }
    }),
  },
};
